<template>
  <div class="-mt-6 bg-black text-white rounded-t-3xl">
    <div class="px-6 md:px-0 flex flex-col-reverse md:flex-row gap-8 md:gap-[60px]">
      <div class="flex-grow md:pt-[240px] md:pl-[180px]">
        <h2 class="text-2xl md:text-5xl text-center md:text-left font-semibold uppercase">{{ t('home.paymentTerminal.title') }}</h2>
        <p class="mt-6 text-md md:text-3xl text-neutral-350">{{ t('home.paymentTerminal.intro1') }}</p>
        <p class="mb-10 text-md md:text-3xl text-neutral-350">{{ t('home.paymentTerminal.intro2') }}</p>
        <div class="text-center md:text-left">
          <VaButton preset="secondary" border-color="white" color="white" round class="h-[68px] !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'contact' }">
            <span class="ml-2.5">{{ t('home.paymentTerminal.contactUs') }}</span>
            <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
              <ArrowRight class="w-4" />
            </div>
          </VaButton>
        </div>
      </div>
      <div class="shrink-0 md:pt-[180px] md:pr-[120px]">
        <img src="@/assets/images/worldline-terminals.png" />
      </div>
    </div>
    <div class="mt-8 md:mt-0 mb-12 flex flex-wrap items-center justify-center md:mx-11 gap-7 md:gap-20 text-neutral-300">
      <VisaIcon />
      <MastercardIcon />
      <MaestroIcon />
      <TwintIcon />
      <PostfinanceIcon />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import ArrowRight from '@/assets/icons/arrow-right.svg'
import MaestroIcon from '@/assets/icons/payment-method/maestro.svg'
import MastercardIcon from '@/assets/icons/payment-method/mastercard.svg'
import PostfinanceIcon from '@/assets/icons/payment-method/postfinance.svg'
import TwintIcon from '@/assets/icons/payment-method/twint.svg'
import VisaIcon from '@/assets/icons/payment-method/visa.svg'

const { t } = useI18n()
</script>
